<cerrix-add-and-filter-bar
  (addButtonClicked)="addButtonClicked.emit()"
  (valueChange)="search($event)"
></cerrix-add-and-filter-bar>
<generic-pagination-list-manager
  [config]="config"
  class="cerrix-filtered-generic-list-manager"
></generic-pagination-list-manager>